import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Box, Snackbar, Alert, AlertColor } from '@mui/material';
import AlertsSection from '../../components/AlertsSection/AlertsSection';
import QuickActions from '../../components/QuickActions/QuickActions';
import InventoryHealthOverview from '../../components/InventoryHealthOverview/InventoryHealthOverview';
import ActivityLog from '../../components/ActivityLog/ActivityLog';

export default function Dashboard() {
  const location = useLocation();
  const stateInput = location.state as { message?: string; alertType?: AlertColor } | null;
  const [toastOpen, setToastOpen] = useState(!!stateInput?.message);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 3,
        }}
      >
        {/* Left Column - Alerts and Quick Actions */}
        <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 66%' } }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <QuickActions />
            <AlertsSection />
            <InventoryHealthOverview />
          </Box>
        </Box>

        {/* Right Column - Activity Log */}
        <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 33%' } }}>
          <ActivityLog />
        </Box>
      </Box>
      <Snackbar
        open={toastOpen}
        autoHideDuration={5000}
        onClose={() => setToastOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity={stateInput?.alertType} onClose={() => setToastOpen(false)}>
          {stateInput?.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}
